class Storage {
    constructor(backingStore) {
        this.__backingStore = backingStore;
    }

    get(key) {
        const valueStr = window[this.__backingStore].getItem(key);
        if (valueStr) {
            try {
                return JSON.parse(valueStr);
            } catch {
                return valueStr;
            }
        }

        return null;
    }

    set(key, value) {
        if (typeof value === "string") {
            window[this.__backingStore].setItem(key, value);
        } else {
            const json = JSON.stringify(value);
            window[this.__backingStore].setItem(key, json);
        }
    }

    remove(key) {
        window[this.__backingStore].removeItem(key);
    }
}

export {
    Storage
}